<script>
import {
  VIRTUAL_CURRENCY_STATUS,
  DIALOG_TITLE_TYPE,
  UPLOAD_IMG_TYPE,
  LANGUAGE,
  getValue
} from "@/utils/enumUtile";
import { formatApiDate } from "@/utils/utils";
import { uploadImgApi } from "@/api/common";
import { getContractList, createContract } from "@/api/contract";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { Message } from "element-ui";
import axios from "axios";

export default {
  computed: {
    VIRTUAL_CURRENCY_STATUS() {
      return VIRTUAL_CURRENCY_STATUS;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    formatApiDate() {
      return formatApiDate;
    },
    getValue() {
      return getValue;
    },
    uploadImgApi() {
      return uploadImgApi;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    LANGUAGE() {
      console.log("LANGUAGE", LANGUAGE);
      return LANGUAGE;
    }
  },
  components: {
    quillEditor
  },
  filters: {},
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      dialogFormVisible: false, // 新增 or 编辑的弹框
      dialogType: "",
      rules: {
        language: [
          { required: true, message: "语言不能为空", trigger: "change" }
        ],
        content: [
          { required: true, message: "内容不能为空", trigger: "change" }
        ]
      },
      form: {
        id: 0,
        language: "", // 名称
        content: "" // 内容
      },
      btnLoading: false,
      editorOption: {
        placeholder: "请输入",
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rt1" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ["link", "image", "video"],
              ["clean"]
            ],
            handlers: {
              //此处是图片上传时候需要使用到的
              image: value => {
                if (value) {
                  // 点击图片
                  document.querySelector(".uploadFile input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              upload: value => {
                console.log("value", value);
                if (value) {
                  // 点击图片
                  document.querySelector(".uploadFile input").click();
                }
              }
            }
          },
          // imageResize: {
          //   // 图片放大缩小
          //   displayStyles: {
          //     backgroundColor: "black",
          //     border: "none",
          //     color: "white"
          //   },
          //   modules: ["Resize", "DisplaySize", "Toolbar"]
          // },
          clipboard: {
            // 剪切板事件
            matchers: [
              ["img", this.handlePasteImg] // 匹配图片剪切板
            ]
          }
        }
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  mounted() {},
  methods: {
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      getContractList(this.listQuery)
        .then(response => {
          this.list = (response.data && response.data.data) || [];
          this.total = response.data.total || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 切换状态
     * @param status
     * @param editObj
     */
    checkDialogFormVisible(status, editObj = {}) {
      if (editObj && Object.keys(editObj).length !== 0) {
        this.form.id = editObj.id;
        this.form.language = editObj.language;
        this.form.content = editObj.content;
      }
      this.dialogFormVisible = status;
      if (!status) {
        this.form.language = null;
        this.form.id = 0;
        this.form.content = null;
        this.$refs.form.resetFields();
      }
    },
    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const params = this.form;
          this.btnLoading = true;
          createContract(params)
            .then(() => {
              this.getList();
              this.checkDialogFormVisible(false);
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    /**
     * 确认上传
     * @param res
     */
    handleSuccess(res) {
      if (res.code === -1) {
        Message({
          message: res.msg,
          type: "error",
          duration: 3 * 1000
        });
        return;
      }
      let quill = this.$refs.myQuillEditor.quill;
      let length = quill.getSelection().index;
      quill.insertEmbed(length, "image", res.data);
      quill.setselection(length + 1);
    },

    handlePasteImg: function(node, delta) {
      // 调整为上传，给回路径
      let _self = this;
      let base64code =
        delta &&
        delta.ops &&
        delta.ops[0] &&
        delta.ops[0]["insert"] &&
        delta.ops[0]["insert"]["image"]; // 2.1
      if (
        base64code &&
        base64code.indexOf("http://") !== 0 &&
        base64code.indexOf("https://") !== 0
      ) {
        // 已经上传的不处理，可自定义判断逻辑
        let file = _self.dataURLtoFile(base64code, "paste.png"); // 2.2
        var formData = new FormData();
        formData.append("file", file);
        formData.append("type", UPLOAD_IMG_TYPE.NEWS);
        // 使用axios发送请求
        axios
          .post(uploadImgApi, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            const resp = response.data;
            if (resp.code !== 0) {
              Message({
                message: resp.msg,
                type: "error",
                duration: 3 * 1000
              });
              return;
            }
            // 获取富文本对象
            let quill = _self.$refs["myQuillEditor"].quill;

            let length = quill.selection.savedRange.index;
            quill.insertEmbed(length, "image", resp.data);
            quill.setselection(length + 1);
          })
          .catch(error => {
            console.error(error);
          });
        // 1、等待请求返回做不到同步，先返回空，在请求回调中再添加（这里监听函数接收职能接收同步的数据，特殊处理）
        delta.ops = [];
        return delta;
      } else {
        return delta;
      }
    },
    // 图片的base64编码转为图片文件
    dataURLtoFile: function(dataurl, name) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name, { type: mime });
    }
  }
};
</script>

<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {})"
        >新增</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
    >
      <el-table-column prop="id" label="编号" width="80"> </el-table-column>
      <el-table-column prop="language" label="语言">
        <template slot-scope="scope">
          {{ getValue(LANGUAGE, scope.row.language) }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="创建时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.created_at) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="修改时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.updated_at) }}</span>
        </template>
      </el-table-column>
      <el-table-columnw
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="checkDialogFormVisible(true, scope.row)"
            style="margin-right: 8px"
            >编辑</el-button
          >
        </template>
      </el-table-columnw>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogType]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @close="checkDialogFormVisible(false, {})"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="语言" prop="language">
          <el-select
            v-model="form.language"
            placeholder="请选择"
            style="width: 100%"
            class="filter-item"
            clearable
            :disabled="form.id !== 0"
          >
            <el-option
              v-for="item in LANGUAGE"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <quill-editor
            v-model="form.content"
            class="content_warp"
            ref="myQuillEditor"
            :options="editorOption"
          ></quill-editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {})">取消</el-button>
        <el-button
          type="primary"
          @click="saveAddOrEditData"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-upload
      :action="uploadImgApi"
      list-type="picture-card"
      class="uploadFile"
      :on-success="handleSuccess"
      :data="{ type: UPLOAD_IMG_TYPE.NEWS }"
      :limit="1"
      :show-file-list="false"
      v-show="false"
    >
    </el-upload>
  </div>
</template>

<style scoped lang="scss">
.content_warp {
  .uploadFile {
    width: 0;
    height: 0;
    display: none;
  }
  /deep/ {
    .ql-container {
      min-height: 400px;
    }
    .ql-editor {
      min-height: 400px;
    }
  }
}
</style>
